import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { UntypedFormBuilder, Validators } from '@angular/forms'
import { BaseError, HttpError } from '../../../../utils/errors'
import { ErrorResponse } from '../../../services/dtos'

@Component({
  selector: 'confirm-action-dialog',
  templateUrl: './confirm-action-dialog.component.html',
  styleUrls: ['./confirm-action-dialog.component.scss'],
  standalone: false,
})
export class ConfirmActionDialogComponent implements OnInit {
  @Input() name: string
  @Input() action: string = 'Delete'
  @Input() error: string
  @Input() busy: boolean = false
  @Output() onAction = new EventEmitter<null>()
  @Output() onCancel = new EventEmitter<null>()

  confirmActionFormModel = this.formBuilder.group({
    confirmation: ['', [Validators.pattern(/\s*i\s+understand\s*/i), Validators.required]],
  })

  constructor(private formBuilder: UntypedFormBuilder) {}

  ngOnInit() {}

  onActionClick() {
    this.onAction.emit(null)
  }

  onCancelClick() {
    this.onCancel.emit(null)
  }

  get actionEnabled() {
    return this.confirmActionFormModel.valid
  }

  get actionButtonText() {
    return this.action.toUpperCase()
  }
}
